<template>
    <group-card
        title="Suitability Assessment"
        icon="quiz"
    >
        <template slot="actions">
            <md-button
                class="md-icon-button md-primary md-simple show-hide"
                @click="toggleSuitabilityAssessment"
            >
                <md-icon id="expand-more" v-if="shouldHide">expand_more</md-icon>
                <md-icon id="expand-less" v-if="!shouldHide">expand_less</md-icon>
                {{ shouldHide ? 'Show' : 'Hide' }}
            </md-button>
        </template>
        <div class="md-layout" v-if="!shouldHide">
            <p class="md-layout-item h5" style="font-weight: bold">Complete suitability assessment questions before you can submit.</p>
        </div>
        <div class="md-layout" v-if="!shouldHide" v-for="(question_and_answers, question_index) in questions_and_answers" :key="question_index">
            <template v-if="question_and_answers.show">
                <!-- Radio Field -->
                <div class="md-layout" v-if="question_and_answers.type == 'radio'">
                    <div class="md-layout-item">
                        {{ getQuestionText(question_and_answers) }}
                    </div>
                    <div>
                        <md-radio
                            v-for="(answer, answer_index) in question_and_answers.answers"
                            :key="answer_index"
                            v-model="question_and_answers.answered_value"
                            :value="answer.value"
                            @change="onQuestionAnswerChange(question_index, answer.value)">
                            {{ answer.text }}
                        </md-radio>
                    </div>
                </div>
                <div class="md-layout" v-else-if="question_and_answers.type == 'text'">
                    <!-- Text Field -->
                    <validated-input
                        class="md-layout-item"
                        :min="question_and_answers.min"
                        :label="getQuestionText(question_and_answers)"
                        prefixLabel="Loan"
                        v-model="question_and_answers.answered_value"
                        :required="question_and_answers.required"
                        @change="onQuestionAnswerChange"
                    >
                    </validated-input>
                </div>
            </template>
        </div>
        <div class="md-layout" v-if="!errorDialog.show && errorDialog.content != ''">
            <div class="md-layout-item md-size-100 error-text" style="padding-top: 0px !important;">
                {{ errorDialog.content }}
            </div>
        </div>

        <md-dialog :md-active.sync="errorDialog.show" :md-click-outside-to-close="false" :md-close-on-esc="false">
          <md-dialog-content>
            <p class="message-height">{{errorDialog.title}}</p>
            <p class="message-height font-bold">{{errorDialog.content}}</p>

            <div class="action-buttons-cover">
              <md-dialog-actions class="action-buttons">
                  <md-button class="md-danger" @click="hideErrorPopup">Ok</md-button>
              </md-dialog-actions>
            </div>
          </md-dialog-content>
        </md-dialog>
    </group-card>
</template>

<script>
import { mapGetters } from 'vuex';
import ValidatedInputs from '@/components/ValidatedInput';
import GroupCard from "@/components/Cards/GroupCard";
import GroupCardRow from "@/components/Cards/GroupCardRow";

export default {
    components: {
        ...ValidatedInputs,
        GroupCard,
        GroupCardRow,
    },
    data() {
        return {
            questions_and_answers: [
                {
                    number: "1",
                    type: "radio",
                    show: true,
                    text: "At the time of this preliminary assessment, is there any evidence to suggest the consumer may have difficulty meeting their new commitments or face substantial hardship during the loan term proposed?",
                    answers: [
                        {
                            text: "Yes",
                            value: "yes"
                        },
                        {
                            text: "No",
                            value: "no"
                        }
                    ],
                    answered_value: "",
                    hidden: [
                        2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
                    ],
                    rules: [
                        {
                            index: 0,
                            value: "no",
                            expose: [
                                1
                            ]
                        },
                    ],
                    rule_fail_message: "Based on your responses any credit assistance provided to the applicant is deemed unsuitable."
                },
                {
                    number: "2",
                    type: "radio",
                    show: false,
                    text: "At the time of this preliminary assessment, is it likely that the consumer will be unable to comply with their financial obligation during the loan term proposed?",
                    answers: [
                        {
                            text: "Yes",
                            value: "yes"
                        },
                        {
                            text: "No",
                            value: "no"
                        }
                    ],
                    answered_value: "",
                    hidden: [
                        3, 4, 5, 6, 7, 8, 9, 10, 11, 12
                    ],
                    rules: [
                        {
                            index: 1,
                            value: "no",
                            expose: [
                                2
                            ]
                        },
                    ],
                    rule_fail_message: "Based on your responses any credit assistance provided to the applicant is deemed unsuitable."
                },
                {
                    number: "3",
                    type: "radio",
                    show: false,
                    text: "At the time of this preliminary assessment, is it likely that the contract will not meet the client’s requirements or objectives for the loan term proposed?",
                    answers: [
                        {
                            text: "Yes",
                            value: "yes"
                        },
                        {
                            text: "No",
                            value: "no"
                        }
                    ],
                    answered_value: "",
                    hidden: [
                        4, 5, 6, 7, 8, 9, 10, 11, 12
                    ],
                    rules: [
                        {
                            index: 2,
                            value: "no",
                            expose: [
                                3
                            ]
                        },
                    ],
                    rule_fail_message: "Based on your responses any credit assistance provided to the applicant is deemed unsuitable."
                },
                {
                    number: "4",
                    type: "radio",
                    show: false,
                    text: "Do you believe that the information provided by the client is true?",
                    answers: [
                        {
                            text: "Yes",
                            value: "yes"
                        },
                        {
                            text: "No",
                            value: "no"
                        }
                    ],
                    answered_value: "",
                    hidden: [
                        4, 5, 6, 7, 8, 9, 10, 11, 12
                    ],
                    rules: [
                        {
                            index: 3,
                            value: "yes",
                            expose: [
                                4
                            ]
                        },
                    ],
                    rule_fail_message: "Your responses indicate you have not met your minimum responsible lending obligations and the application is unable to proceed. Please review"
                },
                {
                    number: "5",
                    type: "radio",
                    show: false,
                    text: "Does the credit report reconcile with commitments disclosed by the client?",
                    answers: [
                        {
                            text: "Yes",
                            value: "yes"
                        },
                        {
                            text: "No",
                            value: "no"
                        }
                    ],
                    answered_value: "",
                    hidden: [
                        5, 6, 7, 8, 9, 10, 11, 12
                    ],
                    rules: [
                        {
                            index: 4,
                            value: "yes",
                            expose: [
                                5
                            ]
                        },
                    ],
                    rule_fail_message: "Your responses indicate you have not met your minimum responsible lending obligations and the application is unable to proceed. Please review"
                },
                {
                    number: "6",
                    type: "radio",
                    show: false,
                    text: "Is there an income surplus evident based on the information supplied by the client?",
                    answers: [
                        {
                            text: "Yes",
                            value: "yes"
                        },
                        {
                            text: "No",
                            value: "no"
                        }
                    ],
                    answered_value: "",
                    hidden: [
                        6, 7, 8, 9, 10, 11, 12
                    ],
                    rules: [
                        {
                            index: 5,
                            value: "yes",
                            expose: [
                                6
                            ]
                        },
                    ],
                    rule_fail_message: "Your responses indicate you have not met your minimum responsible lending obligations and the application is unable to proceed. Please review"
                },
                {
                    number: "7",
                    type: "radio",
                    show: false,
                    text: "Is there an income surplus evident based on capacity guidelines of our lending panel?",
                    answers: [
                        {
                            text: "Yes",
                            value: "yes"
                        },
                        {
                            text: "No",
                            value: "no"
                        }
                    ],
                    answered_value: "",
                    hidden: [
                        7, 8, 9, 10, 11, 12
                    ],
                    rules: [
                        {
                            index: 6,
                            value: "yes",
                            expose: [
                                7
                            ]
                        },
                    ],
                    rule_fail_message: "Your responses indicate you have not met your minimum responsible lending obligations and the application is unable to proceed. Please review"
                },
                {
                    number: "8",
                    type: "radio",
                    show: false,
                    text: "Taking into account the clients surplus and the capacity guidelines of our lending panel, is the proposed credit assistance ‘not unsuitable’?",
                    answers: [
                        {
                            text: "Yes",
                            value: "yes"
                        },
                        {
                            text: "No",
                            value: "no"
                        }
                    ],
                    answered_value: "",
                    hidden: [
                        8, 9, 10, 11, 12
                    ],
                    rules: [
                        {
                            index: 7,
                            value: "yes",
                            expose: [
                                8
                            ]
                        },
                    ],
                    rule_fail_message: "Your responses indicate you have not met your minimum responsible lending obligations and the application is unable to proceed. Please review"
                },
                {
                    number: "9",
                    type: "radio",
                    show: false,
                    text: "Has there been any evidence to suggest the client’s current level of income will not continue?",
                    answers: [
                        {
                            text: "Yes",
                            value: "yes"
                        },
                        {
                            text: "No",
                            value: "no"
                        }
                    ],
                    answered_value: "",
                    hidden: [
                        9, 10, 11, 12
                    ],
                    rules: [
                        {
                            index: 7,
                            value: "yes"
                        },
                        {
                            index: 8,
                            value: "yes",
                            expose: [
                                9
                            ]
                        }
                    ],
                    rule_fail_message: "Your responses indicate you have not met your minimum responsible lending obligations and the application is unable to proceed. Please review"
                },
                {
                    number: "9a",
                    type: "text",
                    show: false,
                    text: "Please Explain",
                    answers: [],
                    answered_value: "",
                    hidden: [
                        10, 11, 12
                    ],
                    expose: [
                        10
                    ],
                    rules: [],
                    min: 20,
                    required : true,
                    rule_fail_message: "Your responses indicate you have not met your minimum responsible lending obligations and the application is unable to proceed. Please review"
                },
                {
                    number: "9b",
                    type: "radio",
                    show: false,
                    text: "Does the applicant have a plan in place to ensure the change to their income will not adversely impact their ability to repay the loan or place them into financial hardship?",
                    answers: [
                        {
                            text: "Yes",
                            value: "yes"
                        },
                        {
                            text: "No",
                            value: "no"
                        }
                    ],
                    answered_value: "",
                    hidden: [
                        11, 12
                    ],
                    rules: [
                        {
                            index: 10,
                            value: "yes",
                            expose: [
                                11
                            ]
                        }
                    ],
                    rule_fail_message: "Your responses indicate you have not met your minimum responsible lending obligations and the application is unable to proceed. Please review"
                },
                {
                    number: "9c",
                    type: "text",
                    show: false,
                    text: "Please Explain",
                    answers: [],
                    answered_value: "",
                    hidden: [
                        12
                    ],
                    expose: [
                        12
                    ],
                    rules: [],
                    min: 20,
                    required : true,
                    rule_fail_message: ""
                },
                {
                    number: "10",
                    type: "radio",
                    show: false,
                    text: "Do you confirm that you have made all enquiries and verifications supporting this application?",
                    answers: [
                        {
                            text: "Yes",
                            value: "yes"
                        },
                        {
                            text: "No",
                            value: "no"
                        }
                    ],
                    answered_value: "",
                    hidden: [],
                    rules: [
                        {
                            index: 12,
                            value: "yes",
                        }
                    ],
                    rule_fail_message: "Your responses indicate you have not met your minimum responsible lending obligations and the application is unable to proceed. Please review"
                },
            ],
            errorDialog: {
                show: false,
                title: "",
                content: "",
            },
            completed: false,
            shouldHide: false
        }
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    computed: {
        // standard list of options from store
        ...mapGetters({
            options: 'options',
        }),

        // internal reference to the v-model on this component, handles incomeing and outgoing changes
        application: {
            get() {
                return this.value;
            },
            set(application) {
                this.$emit("input", application);
            },
        },

        suitabilityAssessment: {
            get() {
                if (this.application.loan.suitability_assessment && this.application.loan.suitability_assessment.length == 0) {
                    return null
                }
                return this.application.loan.suitability_assessment[0];
            },
            set(suitabilityAssessment) {
                if (this.application.loan.suitability_assessment && this.application.loan.suitability_assessment.length > 0) {
                    this.application.loan.suitability_assessment[0] = suitabilityAssessment;
                } else {
                    this.application.loan.suitability_assessment.push(suitabilityAssessment);
                }
            },
        },

        suitabilityAssessmentAvailable () {
            return this.suitabilityAssessment != null;
        },

        hasFinalizedSubmission() {
            return this.application.loan.submission.active.is_settled;
        },

        checkIfTextInput9aIsCompleted() {
            let completed = false;
            let questionAndAnswers = this.questions_and_answers[9];
            if (questionAndAnswers.type == 'text') {
                if (questionAndAnswers.required && questionAndAnswers.answered_value) {
                    completed = true;
                }

                if (questionAndAnswers.min > 0 && questionAndAnswers.answered_value && questionAndAnswers.answered_value.length >= questionAndAnswers.min) {
                    completed = true;
                } else {
                    completed = false;
                }
            }
            return completed;
        },

        checkIfTextInput9cIsCompleted() {
            let completed = false;
            let questionAndAnswers = this.questions_and_answers[11];
            if (questionAndAnswers.type == 'text') {
                if (questionAndAnswers.required && questionAndAnswers.answered_value) {
                    completed = true;
                }

                if (questionAndAnswers.min > 0 && questionAndAnswers.answered_value && questionAndAnswers.answered_value.length >= questionAndAnswers.min) {
                    completed = true;
                } else {
                    completed = false;
                }
            }
            return completed;
        }
    },
    watch: {
        checkIfTextInput9aIsCompleted(newValue, oldValue) {
            if (newValue != oldValue) {
                this.checkQuestionsCompleted(false, 9);
            }
        },

        checkIfTextInput9cIsCompleted(newValue, oldValue) {
            if (newValue != oldValue) {
                this.checkQuestionsCompleted(false, 11);
            }
        },
    },
    methods: {
        updateSuitabilityAssessment() {
            this.suitabilityAssessment = {
                'questions_and_answers' : this.questions_and_answers
            };
        },
        async copySuitabilityAssessment() {
            this.questions_and_answers = this.suitabilityAssessment.questions_and_answers;
        },
        getQuestionText (question_and_answers) {
            return question_and_answers.number + ') ' + question_and_answers.text
        },
        async onQuestionAnswerChange(questionIndex, answerValue) {
            await this.checkQuestionsCompleted(false, questionIndex);
            this.updateSuitabilityAssessment();
        },
        async checkQuestionsCompleted(onLoad = false, currentQuestionIndex = null) {
            this.clearCompleted();
            if (onLoad) {
                for (let i = 0; i < this.questions_and_answers.length; i++) {
                    if (i == 9 || i == 10 || i == 11) {
                        if (this.questions_and_answers[8].answered_value == 'no') {
                            continue;
                        }
                    }

                    if (await this.checkQuestionCompleted(onLoad, i, currentQuestionIndex)) {
                        break;
                    };
                };
            } else {
                let runCheckQuestionCompleted = true;
                if (currentQuestionIndex == 9 || currentQuestionIndex == 10 || currentQuestionIndex == 11) {
                    if (this.questions_and_answers[8].answered_value == 'no') {
                        runCheckQuestionCompleted = false;
                    }
                }

                if (runCheckQuestionCompleted) {
                    await this.checkQuestionCompleted(onLoad, currentQuestionIndex, currentQuestionIndex);
                }
            }
        },
        async checkQuestionCompleted(onLoad, i, currentQuestionIndex) {
            let errorMessage = await this.checkRules(i);
            if (errorMessage == '') {
                let lastQuestionIndex = this.questions_and_answers.length - 1;
                if (i == lastQuestionIndex) {
                    this.checkIfCompleted(onLoad);
                } else {
                    if (!onLoad) {
                        await this.showNextQuestion(i, true, currentQuestionIndex);
                    }
                }
            } else {
                this.showError(
                    "Failed Suitability Assessment.",
                    errorMessage,
                    !onLoad
                );
                await this.showNextQuestion(i, false, currentQuestionIndex);
                return true;
            }

            if (currentQuestionIndex != null && currentQuestionIndex == i) {
                return true;
            }
            return false;
        },
        clearCompleted() {
            this.completed = false;
            this.$emit("completed", false);
        },
        checkIfCompleted(onLoad) {
            this.completed = true;
            if (onLoad) {
                this.shouldHide = true;
            }
            this.$emit("completed", true);
        },
        async checkRules(questionIndex) {
            let checkQuestion9 = this.questions_and_answers[8];
            let checkValidation = true;
            if (questionIndex >= 8 && checkQuestion9.answered_value == 'no' && questionIndex != 12) {
                checkValidation = false;
            }
            let errorMessage = '';
            if (checkValidation) {
                let questionAndAnswers = this.questions_and_answers[questionIndex];
                if (questionAndAnswers.rules && questionAndAnswers.rules.length > 0) {
                    questionAndAnswers.rules.forEach(rule => {
                        let checkQuestionAnwers = this.questions_and_answers[rule.index];
                        if (checkQuestionAnwers.answered_value != rule.value) {
                            errorMessage = questionAndAnswers.rule_fail_message;
                        }
                    });
                } else if (questionAndAnswers.type == 'text') {
                    if (questionAndAnswers.required && !questionAndAnswers.answered_value) {
                        errorMessage = 'Please make sure text inputs have been filled!';
                    } else if (questionAndAnswers.min > 0 && questionAndAnswers.answered_value && questionAndAnswers.answered_value.length < questionAndAnswers.min) {
                        errorMessage = 'Please make sure text inputs have more than ' + questionAndAnswers.min + ' characters';
                    }
                }
            }

            return errorMessage;
        },
        async showNextQuestion(questionIndex, passed = true, currentQuestionIndex) {
            let questionAndAnswers = this.questions_and_answers[questionIndex];
            let checkQuestion9 = this.questions_and_answers[8];
            if (questionIndex == 8) {
                this.clearError();
                if (checkQuestion9.answered_value == 'no') {
                    this.questions_and_answers[9].show = false;
                    this.questions_and_answers[9].answered_value = "";
                    this.questions_and_answers[10].show = false;
                    this.questions_and_answers[10].answered_value = "";
                    this.questions_and_answers[11].show = false;
                    this.questions_and_answers[11].answered_value = "";
                    this.questions_and_answers[12].show = true;
                    this.questions_and_answers[12].answered_value = "";
                } else {
                    this.questions_and_answers[9].show = true;
                    this.questions_and_answers[9].answered_value = "";
                    this.questions_and_answers[10].show = false;
                    this.questions_and_answers[10].answered_value = "";
                    this.questions_and_answers[11].show = false;
                    this.questions_and_answers[11].answered_value = "";
                    this.questions_and_answers[12].show = false;
                    this.questions_and_answers[12].answered_value = "";
                }
            } else {
                if (!passed) {
                    if (questionAndAnswers.hidden && questionAndAnswers.hidden.length > 0) {
                        questionAndAnswers.hidden.forEach(index => {
                            if (this.questions_and_answers[index] != undefined) {
                                this.questions_and_answers[index].show = false;
                                this.questions_and_answers[index].answered_value = "";
                            }
                        });
                    }
                } else if (questionAndAnswers.type == 'text' && questionAndAnswers.expose != undefined && questionAndAnswers.expose.length > 0) {
                    this.clearError();
                    questionAndAnswers.expose.forEach(index => {
                        if (this.questions_and_answers[index] != undefined) {
                            this.questions_and_answers[index].show = true;
                        }
                    });
                } else if (questionAndAnswers.type == 'radio' && questionAndAnswers.rules && questionAndAnswers.rules.length > 0) {
                    this.clearError();
                    questionAndAnswers.rules.forEach(rule => {
                        if (rule.expose != undefined && rule.expose.length > 0 ) {
                            rule.expose.forEach(index => {
                                if (this.questions_and_answers[index] != undefined) {
                                    this.questions_and_answers[index].show = true;
                                }
                            });
                        }
                    });
                }
            }
        },
        showError(title, message, showPop = true) {
            this.errorDialog.title = title;
            this.errorDialog.content = message;
            this.errorDialog.show = showPop;
        },
        hideErrorPopup() {
            this.errorDialog.show = false;
        },
        clearError() {
            this.errorDialog.title = "";
            this.errorDialog.content = "";
            this.errorDialog.show = false;
        },
        toggleSuitabilityAssessment() {
            this.shouldHide = !this.shouldHide;
        },
        async onload() {
            if (!this.suitabilityAssessmentAvailable) {
                this.updateSuitabilityAssessment();
            } else {
                await this.copySuitabilityAssessment();
                await this.checkQuestionsCompleted(true);
            }
        }
    },
    mounted() {
        this.onload();
    },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/theme.scss';
@import '../../assets/scss/md-custom/_ausloans-colors.scss';

button.md-button.md-icon-button.md-primary.md-simple.show-hide {
    width: 150px !important;
    font-size:12px !important;
    color: #ffffff !important;
    background-color: $ausloans-blue !important;
}
#expand-more, #expand-less {
    font-size:20px !important;
    color: #ffffff !important;
}
.show-hide:focus, .show-hide:active, .show-hide:hover {
    box-shadow: 0 14px 26px -12px rgba(33, 150, 243, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(33, 150, 243, 0.2) !important;
    background-color: #128ff2 !important;
}
.error-text {
    color: $color-bad;
    text-align: center;
    font-size: large;
    margin-top: 16px;
}
</style>
